<template>
<div id="app" class="site container hfeed" style="height: auto !important">
  <HeadNav selectedLanguage="en" page="download" />

  <div id="content" class="site-content" style="height: auto !important">
    <article id="article" class="center" style="height: auto !important">
      <section id="downloadpage" style="height: auto !important">
<section class="download-content">
          <div class="download-header">
            <h1>Download OG WhatsApp APK</h1>
            <img src="@/assets/og-whatsapp-logo.png" alt="OG WhatsApp logo" class="download-image">
          </div>

          <div class="download-button-section">
            <button class="download-btn" @click="download()">
              <img src="@/assets/android.svg" alt="android icon">
              Download OG WhatsApp APK
            </button>
          </div>

          <div class="app-info-section">
            <h2>App information</h2>
            <div class="app-info-table">
              <table>
                <tbody>
                  <tr>
                    <th>Name:</th>
                    <td>OG WhatsApp</td>
                  </tr>
                  <tr>
                    <th>Size:</th>
                    <td>80 MB</td>
                  </tr>
                  <tr>
                    <th>Version:</th>
                    <td>18.70</td>
                  </tr>
                  <tr>
                    <th>Updated:</th>
                    <td>2 days ago</td>
                  </tr>
                  <tr>
                    <th>Rating:</th>
                    <td>4.3</td>
                  </tr>
                  <tr>
                    <th>System:</th>
                    <td>Android 5.0+</td>
                  </tr>
                  <tr>
                    <th>Price:</th>
                    <td>Free</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="download-instructions">
            <h2>Install on Android</h2>
            <ol>
              <li>Back up chats in WhatsApp: Settings → Chats → Chat backup.</li>
              <li>Allow installs from unknown sources for your browser (Settings → Apps → Special access, or similar).</li>
              <li>Hit the green button above, then open the APK from notifications or Downloads.</li>
              <li>Tap Install, wait for it to finish, then open the app and verify your number.</li>
            </ol>
          </div>
        </section>
</section>
    </article>
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/download.scss';
import HeadNav from '@/components/HeadNav.vue';

const DOWNLOAD_APK =
  'https://file.gbappapk.org/ow/cp/prod/GB/1778653978581/GBWhatsApp_2.26.19.876_gw_07_14.apk';

export default {
  name: 'Download',
  components: {
    HeadNav,
  },
  // 若后端 getOfficalApk 仍指向 gbwhatsapp.chat，实际 APK 可能与页面显示的「OG」品牌不一致；上线 OG 包时请改域名/渠道配置。
  data() {
    return {
      pageName: 'download',
      showapk: false,

      apk: DOWNLOAD_APK,
      from: 'gb',
      filename: 'gb',
      selectedLanguage: 'en',
    };
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
  },
  methods: {
    downloadfrom(reason) {
      this.download();
      this.$logEvent(`download_from_${reason}`, 'download');
      // window.location.href = `https://gbapp.pro?apps=gb&domain=gbwhatsapp.chat&appName=GB_gbwhatsapp.chat`;
    },
    gotoblog() {
      window.location.href = '/blogs';
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = DOWNLOAD_APK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
            console.log('apk getted');
          } else {
            this.apk = DOWNLOAD_APK;
          }
        });
    },
    download() {
      console.log(this.apk);
      // this.showapk = true
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
    goto(page) {
      this.$router.push({
        name: `${this.selectedLanguage}-${page}`
      });
    }
    // download() {
    // 	console.log(this.apk);
    // 	this.$global.download(this.apk);
    // },
  },
};
</script>

<style lang="scss" scoped>
.download-content {
  max-width: 1100px;
  margin: 1rem auto;
  padding: 40px 20px;
  background: #fff;
  border-radius: 12px;
  // box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.download-header {
  text-align: center;
  margin-bottom: 40px;
}

.download-header h1 {
  color: #204f46;
  font-size: 2.5em;
  font-weight: 700;
  margin-bottom: 30px;
  line-height: 1.2;
}

/* Logo 约 100–200px，居中；小屏不低于 100px */
.download-image {
  display: block;
  width: clamp(100px, 36vw, 200px);
  max-width: 200px;
  height: auto;
  margin: 0 auto;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.download-button-section {
  text-align: center;
  margin: 40px 0;
}

.download-btn {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: #204f46;
  color: #ffffff;
  border: none;
  padding: 18px 32px;
  border-radius: 4px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s ease, transform 0.3s ease;
  box-shadow: none;
}

.download-btn:hover {
  transform: translateY(-2px);
  background: #34d399;
  color: #ffffff;
  box-shadow: none;
}

.download-btn img {
  width: 24px;
  height: 24px;
  filter: brightness(0) invert(1);
}

.app-info-section {
  margin: 40px 0;
}

.app-info-section h2 {
  color: #333333;
  font-size: 1.8em;
  font-weight: 700;
  margin-bottom: 20px;
  text-align: center;
}

.app-info-table {
  background: #f8f9fa;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.app-info-table table {
  width: 100%;
  border-collapse: collapse;
}

.app-info-table th,
.app-info-table td {
  padding: 16px 20px;
  text-align: left;
  border-bottom: 1px solid #e9ecef;
}

.app-info-table th {
  background: #ffffff;
  color: #204f46;
  border-bottom: 1px solid #e5e5e5;
  font-weight: 600;
  width: 40%;
}

.app-info-table tr:last-child td,
.app-info-table tr:last-child th {
  border-bottom: none;
}

.download-instructions {
  margin: 40px 0;
}

.download-instructions h2 {
  color: #333333;
  font-size: 1.8em;
  font-weight: 700;
  margin-bottom: 20px;
  text-align: center;
}

.download-instructions ol {
  background: #f8f9fa;
  padding: 30px 40px;
  border-radius: 12px;
  border-left: 4px solid #34d399;
}

.download-instructions li {
  margin-bottom: 15px;
  line-height: 1.6;
  font-size: 16px;
}

.download-instructions li:last-child {
  margin-bottom: 0;
}

.download-lead {
  font-size: 16px;
  line-height: 1.55;
  color: #444;
  text-align: center;
  max-width: 640px;
  margin: 0 auto 28px;
}

.apk-note {
  font-size: 14px;
  color: #444;
  line-height: 1.5;
  margin-bottom: 16px;
  text-align: center;
  max-width: 640px;
  margin-left: auto;
  margin-right: auto;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .download-content {
    padding: 20px 15px;
  }
  
  .download-header h1 {
    font-size: 2em;
  }
  
  .download-btn {
    padding: 15px 25px;
    font-size: 16px;
  }
  
  .download-btn img {
    width: 20px;
    height: 20px;
  }
  
  .app-info-table th,
  .app-info-table td {
    padding: 12px 15px;
    font-size: 14px;
  }
  
  .download-instructions ol {
    padding: 20px 25px;
  }
  
  .download-instructions li {
    font-size: 14px;
  }
}
</style>
